import { NewsAndPromotionType } from './NewsAndPromotionType'

export class NewsAndPromotionResponse {
  data: NewsAndPromotionType[]

  total: number

  page: number
}
